const config = {
  node_env: process.env.REACT_APP_NODE_ENV || 'local',
  back_end_url: process.env.REACT_APP_API_URI,
  upload_file_size_in_mb: process.env.REACT_APP_UPLOAD_FILE_SIZE_IN_MB,
  websocket_url: process.env.REACT_APP_WEBSOCKET_URI,
};

export default config;
